import { Directive } from '@angular/core';
import { filter, map, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { IResidentAppSettings, TicketingVersion, WhitelabelImage } from '../../models';
import { getPermissions, getResidentAppSettings } from '../../+state';
import { CustomerService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive()
export class DashboardPageBaseComponent {
  public whitelabelImage = WhitelabelImage;
  public residentAppSettings: IResidentAppSettings;
  public $showWidget = this.store.select(getPermissions).pipe(
    map(permissions => permissions),
    filter(permission => permission !== null),
    takeUntilDestroyed()
  );
  public $showTicketing = this.store.select(getResidentAppSettings).pipe(
    filter(residentAppSettings => residentAppSettings !== null),
    tap(residentAppSettings => {
      this.residentAppSettings = residentAppSettings;
    }),
    map(
      ({ ticketingVersion }) =>
        !this.customerService.hideTicketManagement() &&
        ticketingVersion === TicketingVersion.METADATA
    ),
    takeUntilDestroyed()
  );

  constructor(
    protected store: Store,
    protected customerService: CustomerService
  ) {}
}
